import get from 'lodash.get';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  stampsServiceName: {
    description: 'stampsDhl.stampsDhlServiceName',
    defaultMessage: 'ShipStation Carrier Services',
    id: 'MHH3CK',
  },
});

const stampsDhlWalletLabelProviderId = 38;
const stampsLabelProviderId = 2;

class StampsWalletDHLServiceClass {
  hasFulfillmentWithStampsWalletDhlService(labelProviders, fulfillmentPlans) {
    if (!fulfillmentPlans || !fulfillmentPlans.length || !labelProviders || !labelProviders.length) {
      return false;
    }
    return fulfillmentPlans.reduce((hasStampsDhlProvider, fulfillmentPlan) => {
      // batch grid shipments don't have the labelConfiguration prop
      const sellerLabelProviderId =
        get(fulfillmentPlan, 'labelConfiguration.sellerLabelProviderId') || fulfillmentPlan.sellerLabelProviderId;
      if (!sellerLabelProviderId) {
        return hasStampsDhlProvider;
      }
      const selectedLabelProvider = labelProviders.find((provider) => provider.sellerLabelProviderId === sellerLabelProviderId);
      if (!selectedLabelProvider) {
        return hasStampsDhlProvider;
      }
      const { labelProviderId } = selectedLabelProvider;
      return hasStampsDhlProvider || (!hasStampsDhlProvider && parseInt(labelProviderId, 10) === stampsDhlWalletLabelProviderId);
    }, false);
  }

  isStampsDhlProvider(providerId) {
    return providerId === stampsDhlWalletLabelProviderId || providerId === stampsLabelProviderId;
  }

  getStampsDhlProviderDisplayInformation() {
    return {
      displayName: messages.stampsServiceName,
    };
  }
}

export const StampsWalletDHLService = new StampsWalletDHLServiceClass();
